<template>
  <div :class="['search-bar', dateFilter ? 'search-bar--filters' : '']">
    <div class="grid-x align-middle">
      <div class="cell auto">
        <div class="search-bar__search">
          <i class="fa-search far"></i>

          <input name="search" type="text" :placeholder="placeholder"
                 :value="value"
                 v-on:keyup.enter="search($event.target.value)">
        </div>
      </div>

      <div class="cell medium-shrink" v-if="filter">
        <div class="filter-selector">
          <div class="filter-selector__label" @click="openPaymentFilter">
            <div>Visibility</div>

            <i class="fas fa-sort-down"></i>
          </div>

          <div id="payment-filter" class="filter-selector__fields">
            <label>
              <checkbox></checkbox>
              Hidden</label>
          </div>
        </div>
      </div>

      <div class="cell medium-shrink" v-if="hiddenFilter">
        <div class="filter-selector">
          <div class="filter-selector__label" @click="openHiddenFilter">
            <div>Status</div>

            <i class="fas fa-sort-down"></i>
          </div>

          <div class="filter-selector__fields" v-if="hiddenFilterOpen">
            <label @click="checkHidden">
              <div :class="['checkbox-choice', hiddenActive ? 'active': '']"></div>
              Hidden</label>

            <div class="text-right" style="margin-top: 10px;">
              <button class="button--small" @click="filterHidden">Filter</button>
            </div>
          </div>
        </div>
      </div>

      <div class="cell medium-shrink" v-if="paidFilter">
        <div class="filter-selector">
          <div class="filter-selector__label" @click="openPaymentFilter">
            <div>Payment Status</div>

            <i class="fas fa-sort-down"></i>
          </div>

          <div class="filter-selector__fields" v-if="paidFilterOpen">
            <label @click="checkPaid">
              <div :class="['checkbox-choice', paidActive ? 'active': '']"></div>
              Paid</label>

            <label @click="checkUnpaid">
              <div :class="['checkbox-choice', unpaidActive ? 'active': '']"></div>
              Unpaid</label>

            <div class="text-right" style="margin-top: 10px;">
              <button class="button--small" @click="filterPaid">Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="cell medium-shrink" v-if="dateFilter">
        <div class="date-selector">
          <div class="date-selector__label" @click="openDateFilter">
            <div>Date Range</div>

            <i class="far fa-calendar-alt"></i>
          </div>

          <div id="date-filter" class="date-selector__fields"
               v-if="dateFilterOpen">
            <div class="grid-x grid-padding-x align-top">
              <div class="cell auto">
                <label>Start Date</label>
                <datepicker :id="'start-date'" :format="dateFormat"
                            :clear-button="true"
                            :placeholder="'Jan 1, 1970'"
                            :open-date="startDate"
                            :value="startDate"
                            @cleared="startDateSelected"
                            @selected="startDateSelected"></datepicker>
              </div>

              <div class="cell auto">
                <label>End Date</label>
                <datepicker :id="'end-date'" :format="dateFormat"
                            class="end-date"
                            :clear-button="true"
                            :placeholder="'Dec 31, 2099'"
                            :open-date="endDate"
                            :value="endDate"
                            @cleared="endDateSelected"
                            @selected="endDateSelected"></datepicker>

                <div class="text-right" style="margin-top: 10px;">
                  <button class="button--small" @click="filterDate">Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell medium-shrink" v-if="sortOptions">
        <div class="grid-x grid-padding-x align-middle">
          <div class="search-bar__sort-by cell shrink">Sort by</div>

          <div class="cell auto medium-shrink">
            <div class="select-field">
              <select @change="sort($event.target.value)">
                <option :value="option.value"
                        v-for="(option, key) in sortOptions" :key="key"
                        :selected="option.default">{{ option.label }}
                </option>
              </select>

              <i class="fas fa-sort"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/globals/checkbox'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Checkbox,
    Datepicker
  },
  props: [
    'placeholder',
    'value',
    'sortOptions',
    'dateFilter',
    'paidFilter',
    'hiddenFilter',
    'filter'
  ],
  data: function () {
    return {
      hiddenFilterOpen: false,
      dateFilterOpen: false,
      paidFilterOpen: false,
      hiddenActive: false,
      paidActive: true,
      unpaidActive: true,
      startDate: null,
      endDate: null
    }
  },
  methods: {
    checkPaid () {
      this.paidActive = !this.paidActive
    },
    checkUnpaid () {
      this.unpaidActive = !this.unpaidActive
    },
    checkHidden () {
      this.hiddenActive = !this.hiddenActive
    },
    filterHidden () {
      this.hiddenFilterOpen = false

      if (this.hiddenActive) {
        this.$emit('hiddenFilter', true)
      } else {
        this.$emit('hiddenFilter', false)
      }
    },
    filterPaid () {
      this.paidFilterOpen = false

      if (this.paidActive && !this.unpaidActive) {
        this.$emit('paidFilter', true)
      } else if (!this.paidActive && this.unpaidActive) {
        this.$emit('paidFilter', false)
      } else {
        this.$emit('paidFilter', null)
      }
    },
    dateFormat (date) {
      return moment(date).format('MMM D, YYYY')
    },
    startDateSelected (date) {
      this.startDate = date
    },
    endDateSelected (date) {
      this.endDate = date
    },
    search: function (value) {
      this.$emit('search', value)
    },
    sort: function (value) {
      this.$emit('sort', value)
    },
    openHiddenFilter () {
      this.hiddenFilterOpen = !this.hiddenFilterOpen
    },
    openPaymentFilter: function () {
      this.dateFilterOpen = false
      this.paidFilterOpen = !this.paidFilterOpen
    },
    openDateFilter: function () {
      this.paidFilterOpen = false
      this.dateFilterOpen = !this.dateFilterOpen
    },
    filterDate () {
      let startDate = ''
      let endDate = ''

      if (this.startDate !== null && this.startDate !== undefined) {
        startDate = moment(this.startDate).format('YYYY-MM-DD')
      }

      if (this.endDate !== null && this.endDate !== undefined) {
        let newDate = new Date(this.endDate.setTime(this.endDate.getTime()))
        endDate = moment(newDate).format('YYYY-MM-DD')
      }

      this.dateFilterOpen = false

      this.$emit('dateFilter', startDate, endDate)
    }
  }
}
</script>

<style lang="scss">
@import "~foundation-sites/scss/foundation";
@import '../styles/mixins';
@import '../styles/variables';

.search-bar {
  padding: 15px 15px 5px;

  .end-date .vdp-datepicker__calendar {
    left: auto;
    right: 0;
  }

  &__filter {
    background: $darker2-gray;
    border: 1px solid $darker-gray;
    border-right: 0;
    border-radius: 3px 0 0 3px;
    color: $white;
    line-height: 38px;
    padding: 0 20px;

    .fa-plus {
      font-size: 9px;
      position: relative;
      top: -1px;
    }

    &:hover {
      background: darken($darker-gray, 5%);
      color: $black;
    }
  }

  &__search {
    position: relative;

    input {
      padding: .5em .5em .5em 35px;
    }

    .fa-search {
      color: #aaaaaa;
      left: 10px;
      position: absolute;
      top: 12px;
    }
  }

  &__sort-by {
    @include breakpoint(medium) {
      padding: 0 !important;
    }
  }

  &__filters {
    position: relative;
    z-index: 9;

    &__selector {
      @include shadow(0 0 5px 0 $medium-gray);
      background: $white;
      border: 1px solid $medium-gray;
      left: 0;
      padding: 10px;
      position: absolute;
      top: 0;
    }
  }

  .filter-selector {
    position: relative;
    z-index: 2;

    &__label {
      background: $darker-gray;
      border: 1px solid $dark2-gray;
      border-right: 0;
      cursor: pointer;
      line-height: 38px;
      padding: 0 15px;
      position: relative;
      min-width: 200px;

      svg {
        position: absolute;
        right: 15px;
        top: 10px;
      }

      &:hover {
        background: darken($darker-gray, 2%);
      }
    }

    &__fields {
      background: $darker-gray;
      border: 1px solid $dark2-gray;
      margin-top: -1px;
      padding: 10px 10px 15px;
      position: absolute;
      right: 0;
      top: 100%;
      min-width: 199px;

      label {
        display: block;
      }
    }

    &.open {
      .date-selector {
        &__fields {
          display: block;
        }
      }
    }
  }

  .date-selector {
    position: relative;
    z-index: 2;

    &__label {
      background: $darker-gray;
      border: 1px solid $dark2-gray;
      border-radius: 0 5px 5px 0;
      cursor: pointer;
      line-height: 38px;
      padding: 0 15px;
      position: relative;
      min-width: 200px;

      svg {
        position: absolute;
        right: 15px;
        top: 10px;
      }

      &:hover {
        background: darken($darker-gray, 2%);
      }
    }

    &__fields {
      background: $darker-gray;
      border: 1px solid $dark2-gray;
      border-radius: 0 0 5px 5px;
      margin-top: -1px;
      padding: 10px 10px 15px;
      position: absolute;
      right: 0;
      top: 100%;
      width: 450px;
    }

    &.open {
      .date-selector {
        &_label {
          border-radius: 0 5px 0 0;
        }

        &__fields {
          display: block;
        }
      }
    }
  }

  &--filters {
    .search-bar {
      &__search {
        input {
          border-radius: 5px 0 0 5px;
        }
      }
    }
  }
}

.light-theme {
  .search-bar {
    &__filter {
      background: $lightest-gray;
      border: 1px solid $medium-gray;
      color: $black;

      &:hover {
        background: darken($lightest-gray, 5%);
        color: $black;
      }
    }

    &__search {
      .fa-search {
        color: #aaaaaa;
      }
    }

    &__filters {
      &__selector {
        @include shadow(0 0 5px 0 $medium-gray);
        background: $white;
        border: 1px solid $medium-gray;
      }
    }

    .filter-selector {
      &__label {
        background: $lightest-gray;
        border: 1px solid $medium-gray;

        &:hover {
          background: darken($lightest-gray, 1%);
        }
      }

      &__fields {
        background: $white;
        border: 1px solid $medium-gray;
      }
    }

    .date-selector {
      &__label {
        background: $lightest-gray;
        border: 1px solid $medium-gray;

        &:hover {
          background: darken($lightest-gray, 1%);
        }
      }

      &__fields {
        background: $white;
        border: 1px solid $medium-gray;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/searchBar.vue